import PropTypes from "prop-types";

export const userTypes = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    family_name: PropTypes.string,
    city_id: PropTypes.number,
    email: PropTypes.string,
    gender: PropTypes.string,
    height: PropTypes.number,
    avatar: PropTypes.shape({
        url: PropTypes.string,
        cropped_image_url: PropTypes.string,
        full_image_url: PropTypes.string,
    }),
});

export const gameTypes = {
    id: PropTypes.number,
    type_id: PropTypes.number,
    starts_at: PropTypes.string,
    duration: PropTypes.number,
    level_id: PropTypes.number,
    max_players: PropTypes.number,
    cost: PropTypes.number,
    players_gender: PropTypes.string,
    playground_id: PropTypes.number,
    playground: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
    }),
    city_id: PropTypes.number,
    description: PropTypes.string,
    is_public: PropTypes.bool,
    is_participate: PropTypes.bool,
    is_training: PropTypes.bool,
    organizer_id: PropTypes.number,
    trainer_id: PropTypes.number,
    organizer: PropTypes.shape(userTypes),
    trainer: PropTypes.shape(userTypes),
    is_past: PropTypes.bool,
    need_report: PropTypes.bool,
    invitations: PropTypes.array,
    periodicity: PropTypes.string,
    unsubscribe_hours: PropTypes.number,
    age_limit: PropTypes.bool,
};
